// src/pages/facility/ViewFacilityPage.jsx

import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import FacilityFormPage from "./FacilityFormPage";

const ViewAddFacilityPage = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb for page title and navigation */}
      <Breadcrumb 
        id="title" 
        title2="Facilities" 
        link2="/facilities" 
        title="Facility Add" 
      />
      <FacilityFormPage/>
    </MasterLayout>
  );
};

export default ViewAddFacilityPage;
